import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changePersonStatus'
})
export class ChangePersonStatusPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Bloquear' : 'Desbloquear';
  }
}
